export default __webpack_public_path__ + "static/media/20.0ac690bb.mp3";